module.exports = __webpack_public_path__ + "fonts/pfbenchmarkpro-bolditalic.6a483db.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/pfbenchmarkpro/pfbenchmarkpro-bolditalic.ttf
// module id = 167
// module chunks = 245 246